







import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import TsNpsNumber from './TsNpsNumber.vue'
import TsNpsStats from './TsNpsStats.vue'
import TsNpsCurrentGroupV2 from '@/components/TeamScoreboard/TsNpsCurrentGroupV2.vue'
import { getOrdinal } from '@/utils/number'
import TsNpsInfo from '@/components/TeamScoreboard/TsNpsInfo.vue'

@Component<TsNpsOverallV2>({
    components: {
        TsNpsInfo,
        TsNpsCurrentGroupV2,
        TsNpsNumber,
        TsNpsStats
    },
    filters: {
        getOrdinal
    }
})
export default class TsNpsOverallV2 extends Vue {
    @Prop({type: Boolean, default: false})
    isMobile
}
